import { FCC } from "@/types/common";
import { Stack, Typography } from "@mui/material";
import { InnerBox } from "@/components/elements/InnerBox";
import { divider } from "@/theme/colors";
import { TGetPartnerDto } from "@/api/services/main/partner/dtos/get-partner.dto";
import { PartnerInfoItem } from "@/features/partner/components/partner-detail/PartnerInfoItem";
import { PartnerFlagTag } from "@/features/partner/components/partner-detail/PartnerFlagTag";

type TPartnerBasicInfoProps = {
  partner: TGetPartnerDto;
};

export const PartnerBasicInfo: FCC<TPartnerBasicInfoProps> = ({ partner }) => {
  const flags = (
    <>
      {partner.sendingOrganization && <PartnerFlagTag label="送り出し機関" />}
      {partner.laborBureauStatus && <PartnerFlagTag label="労働局届出済み" />}
    </>
  );

  return (
    <InnerBox title={<Typography variant="sub16Bold">基本情報</Typography>} showDivider={false} borderColor={divider.high} sx={{ gap: "24px" }}>
      <Stack gap={2}>
        <PartnerInfoItem label="パートナー管理番号" value={partner.managementNumber} />
        <PartnerInfoItem label="パートナー名" value={partner.partnerName} affix={flags} />
        <PartnerInfoItem label="国籍" value={partner.nationality?.nationalityName} />
        <Stack direction="row" alignItems="flex-start" gap={3}>
          <PartnerInfoItem label="郵便番号" value={partner.zipCode} type="zipcode" />
          <PartnerInfoItem label="都道府県" value={partner.prefecture} />
          <PartnerInfoItem label="市区町村" value={partner.city} />
        </Stack>
        <PartnerInfoItem label="町名丁目番地号等" value={partner.address} />
        <PartnerInfoItem label="所在地" value={partner.location} showDivider={false} />
      </Stack>
    </InnerBox>
  );
};
